import * as React from 'react';
import { cn } from '@/lib/utils';
import { AITextHelper } from '@/components/ai/AITextHelper';
import { RichTextEditor } from '@/components/ui/rich-text-editor';
import { plainTextToRichHtml, stripHtmlToText } from '@/lib/html-utils';

export interface AIRichTextEditorProps {
  value: string;
  onValueChange: (value: string) => void;
  aiContext?: string;
  aiFieldLabel?: string;
  aiDisabled?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  editorClassName?: string;
}

export function AIRichTextEditor({
  value,
  onValueChange,
  aiContext,
  aiFieldLabel,
  aiDisabled,
  placeholder,
  disabled,
  className,
  editorClassName,
}: AIRichTextEditorProps) {
  const aiPlain = stripHtmlToText(value);

  const handleAiPlain = (plain: string) => {
    onValueChange(plainTextToRichHtml(plain));
  };

  return (
    <div className={cn('relative w-full min-w-0', className)}>
      <RichTextEditor
        value={value}
        onChange={onValueChange}
        placeholder={placeholder}
        disabled={disabled}
        editorClassName={editorClassName}
        aria-label={aiFieldLabel ?? 'Rich-Text'}
      />
      <div className="pointer-events-none absolute inset-0 min-h-[260px]">
        <AITextHelper
          value={value}
          aiTextValue={aiPlain}
          onValueChange={handleAiPlain}
          context={aiContext}
          fieldLabel={aiFieldLabel}
          disabled={aiDisabled ?? disabled}
          placement="textarea"
          className="h-full w-full min-w-0"
        />
      </div>
    </div>
  );
}
